export default "/images/2b9df5fde8bb8412f7c1bad5824f5a74.png";